window.SystemJS = window.System;

function insertNewImportMap(newMapJSON) {
  const newScript = document.createElement('script');
  newScript.type = 'systemjs-importmap';
  newScript.text = JSON.stringify(newMapJSON);
  const allMaps = document.querySelectorAll('script[type="systemjs-importmap"]');

  allMaps[allMaps.length - 1].insertAdjacentElement('afterEnd', newScript);
}

const devDependencies = {
  imports: {
    react: 'https://unpkg.com/react@17.0.2/umd/react.development.js',
    'react-dom': 'https://unpkg.com/react-dom@17.0.2/umd/react-dom.development.js',
    'react-dom/server':
      'https://unpkg.com/react-dom@17.0.2/umd/react-dom-server.browser.development.js',
    'react-router-dom': 'https://unpkg.com/react-router-dom@5.2.0/umd/react-router-dom.js',
    //'@material-ui/core': 'https://unpkg.com/@material-ui/core@4.6.0/umd/material-ui.development.js',
    lodash: 'https://unpkg.com/lodash@4.17.21/lodash.js',
  },
};

const prodDependencies = {
  imports: {
    react: 'https://unpkg.com/react@17.0.2/umd/react.production.min.js',
    'react-dom': 'https://unpkg.com/react-dom@17.0.2/umd/react-dom.production.min.js',
    'react-dom/server':
      'https://unpkg.com/react-dom@17.0.2/umd/react-dom-server.browser.production.min.js',
    'react-router-dom': 'https://unpkg.com/react-router-dom@5.2.0/umd/react-router-dom.min.js',
    //'@material-ui/core': 'https://unpkg.com/@material-ui/core@4.6.0/umd/material-ui.production.min.js',
    lodash: 'https://unpkg.com/lodash@4.17.21/lodash.min.js',
  },
};

const prodMode = PRODUCTION;
if (prodMode) {
  insertNewImportMap(prodDependencies);
} else {
  insertNewImportMap(devDependencies);
}
